
<template>
  <main>
    <fade-in-top-title class="title-interval">
      <h3>About</h3>
    </fade-in-top-title>
    <fade-in-main>
      <div class="container">
        <div class="about-wrapper">
          <div class="about-left-wrapper">
            <img src="@/assets/images/about01.png" alt="">
          </div>
          <div class="about-right-wrapper">
            <h3>TOSHIHIRO YUASA</h3>
            <p>千葉県 船橋生まれ。<br>高校卒業後、音響芸術専門学校に入学。卒業後に映像会社に就職。<br>3年務めたのち、CRIに転職。</p>
            <p>現在は、四ツ谷にて勤務。</p>
            <p>&#12298;スキル&#12299;</p>
            <ul>
              <li>RDBMS(PostgreSQL)を仕様した業務</li>
              <li>Javaのプログラム修正</li>
              <li>PT工程（単体テスト）</li>
              <li>Excel：表計算、関数</li>
              <li>Word：文書作成全般</li>
              <li>PowerPoint：企画書、レギュレーション資料作成</li>
              <li>Illustrator：テロップ制作/簡単なイラスト制作/ショートカット(基礎＋応用)の操作</li>
              <li>Photoshop：画像加工/テロップ制作/簡単なイラスト制作/ショートカット(基礎＋応用)の操作</li>
            </ul>
          </div>
        </div>
      </div>
    </fade-in-main>
  </main>
</template>



<script>
import FadeInMain from '@/components/FadeInMain.vue';
import FadeInTopTitle from '@/components/FadeInTopTitle.vue';

export default {
  components: {
    FadeInMain,
    FadeInTopTitle
  }
}
</script>

<style lang="scss" scoped>
.about-wrapper {
  display: flex;
  justify-content: space-between;
  margin: 100px 40px;
  @include  tablet {
    display: block;
  }
  @include  mobile {
    display: block;
  }
}

.about-left-wrapper {
width: 50%;
  @include  tablet{
    width: 100%;
  }
  @include  mobile{
    width: 100%;
  }
}

.about-right-wrapper {
width: 45%;
text-align: left;
font-size: 13px;
vertical-align: top;
  @include  tablet{
    width: 100%;
  }
  @include  mobile{
    width: 100%;
  }
}

p {
  padding-bottom: 10px;
}
</style>